export const peopleUrlList = '/people'
export const insightsPageUrl = '/insights'
